import React from 'react'
import { useVersioning } from '../../../../../versioning'
import {
  SFSymbolLabel,
  LoadPageSeparator,
  handleFetchMore,
} from '@sketch/components'
import {
  FrameDetailInfoFragment,
  ArtboardDetailInfoFragment,
  GetFramesForPageQuery,
  GetFramesForPageQueryVariables,
} from '@sketch/gql-types'
import { dataIdFromObject } from '@sketch/graphql-cache'
import { ObservableQuery } from '@apollo/client'

import * as S from './FrameList.styles'
import { Skeleton } from './FrameList.styles'

interface FrameListProps {
  frames: (FrameDetailInfoFragment | ArtboardDetailInfoFragment)[]
  after: string | null
  fetchMore?: ObservableQuery<
    GetFramesForPageQuery,
    GetFramesForPageQueryVariables
  >['fetchMore']
  shareIdentifier: string
  currentFrameUUID: string
  /**
   * Number of frames we haven't loaded yet
   */
  remainingFramesToLoad: number
}

export function FrameList({
  frames,
  after,
  fetchMore,
  shareIdentifier,
  currentFrameUUID,
  remainingFramesToLoad,
}: FrameListProps) {
  const { getPathname } = useVersioning()

  const placeholderCount = Math.min(remainingFramesToLoad, 5)

  return (
    <>
      {frames.map(frame => {
        const { identifier, name, uuid } = frame
        const pathname = getPathname({
          routeKey: 'FRAME',
          routeParams: {
            shareID: shareIdentifier,
            frameUUID: uuid,
          },
        })

        return (
          <S.StyledDropdownNavItem
            key={identifier}
            data-testid="frame-selector-item"
            to={pathname}
            isActive={match => Boolean(match) || uuid === currentFrameUUID}
            exact
          >
            <SFSymbolLabel text={name} />
          </S.StyledDropdownNavItem>
        )
      })}

      {after && (
        <li>
          <LoadPageSeparator
            key={after}
            loadNewPage={handleFetchMore(
              fetchMore,
              ['share', 'version', 'document', 'page', 'frames', 'entries'],
              {
                dataIdFromObject,
                after,
              }
            )}
          />
          <>
            {[...Array(placeholderCount)].map((_, index) => (
              <Skeleton key={index} />
            ))}
          </>
        </li>
      )}
    </>
  )
}
